export { default as LockedOffersCard } from './locked-offers-card';
